import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AddExpensePage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to payables page with focus param
    navigate("/transactions/expenses?focus=cost_center", { replace: true });
  }, [navigate]);

  return null;
}

